import React from "react";

const VARIANT_CLASS_MAP = {
  danger: "ui-btn--danger",
  navy: "ui-btn--navy",
  utility: "ui-btn--utility",
  blue: "ui-btn--blue",
  green: "ui-btn--green",
  ghost: "ui-btn--ghost",
};

const SIZE_CLASS_MAP = {
  sm: "ui-btn--sm",
  md: "ui-btn--md",
  lg: "ui-btn--lg",
};

const ButtonBase = ({
  variant = "danger",
  size = "md",
  className = "",
  type = "button",
  children,
  ...rest
}) => {
  const variantClass = VARIANT_CLASS_MAP[variant] || VARIANT_CLASS_MAP.danger;
  const sizeClass = SIZE_CLASS_MAP[size] || SIZE_CLASS_MAP.md;

  return (
    <button
      type={type}
      className={`ui-btn ${variantClass} ${sizeClass} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
};

export const PrimaryButton = (props) => <ButtonBase variant="danger" {...props} />;

export const SecondaryButton = (props) => <ButtonBase variant="navy" {...props} />;

export default ButtonBase;
